export const REFRESH_USER_COUNT = 'REFRESH_USER_COUNT';

import { get, put, post, destroy, upload } from 'utils/fetchRequest';

export const uploadImage = async (data) => {
    try {
        const result = await upload('files/news', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getNewsList = async (searchText, page, pageLimit, type, notSpecial) => {
    try {
        const result = await get(
            `news?1=1${searchText ? `&search=${searchText}` : ''}${page ? `&page=${page}` : ''}${pageLimit ? `&limit=${pageLimit}` : ''}${type ? `&type=${type}` : ''}${notSpecial ? `&notSpecial=${notSpecial}` : ''}`
        );

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getNewsContent = async (newsId) => {
    try {
        const result = await get(`news/${newsId}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const setNewsSeen = async (newsId) => {
    try {
        const result = await put(`news/seen/${newsId}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const createNews = async (data) => {
    try {
        const result = await post('news', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const updateNews = async (id, data) => {
    try {
        const result = await put(`news/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const deleteNews = async (id) => {
    try {
        const result = await destroy(`news/${id}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const setSpecial = async (id, data) => {
    try {
        const result = await put(`news/special/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const setActive = async (id, data) => {
    try {
        const result = await put(`news/active/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getSpecialNews = async () => {
    try {
        const result = await get(`news/special`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

// export const subscribeUser = async (id) => {
//     try {
//         const result = await put(`payment/admin/${id}`);

//         return result;
//     } catch (err) {
//         return { error: err };
//     }
// };

// export const getUserCount = async () => {
//     try {
//         const result = await get(`users/count`);

//         return result;
//     } catch (err) {
//         return { error: err };
//     }
// };
